import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';

import { debounce } from '@/helpers';

/**
 * @param {object} gallery
 */
export const photoswipeVideos = gallery => {
    let player;
    let added = false;

    gallery.listen('gettingData', (index, item) => {
        // console.log('gettingData', index, item);

        if (item.type === 'video' && !added) {
            added = true;

            let classes = '';
            if (item.title) classes = 'pswp-with-title';

            // style="width: ${item.w}px; height: ${item.h}px"
            // item.html = `
            //   <div class="pswp-video-container ${classes}">
            //     <a class="pswp-video-bypass-click-prevention">
            //       <div
            //         class="pswp-video-size-limiter"
            //         style="width: ${item.width}px; padding-bottom: ${(item.height / item.width) * 100}%"
            //         >
            //         <video
            //           id="pswp-video-${item.id}"
            //           class="video-js vjs-city-offer vjs-show-big-play-button-on-pause"
            //           width="${item.width}" height="${item.height}"
            //           style="opacity: 0"
            //           controls
            //           >
            //           <source src="${item.src}" type="${item.mime}">
            //         </video>
            //       </div>
            //     </a>
            //   </div>
            // `;

            item.html = `
        <div class="pswp-video-container ${classes}">
          <a class="pswp-video-bypass-click-prevention">
            <video
              id="pswp-video-${item.id}"
              class="video-js vjs-city-offer vjs-show-big-play-button-on-pause"
              width="${item.width}" height="${item.height}"
              style="opacity: 0"
              controls
              >
              <source src="${item.src}" type="${item.mime}">
            </video>
          </a>
        </div>
      `;

            item.video = item.src;
            delete item.src;
        }
    });

    gallery.listen('afterChange', () => {
        const { currItem: item } = gallery;

        if (item.type === 'video') {
            const element = document.getElementById(`pswp-video-${item.id}`);

            const aspectRatio = item.width / item.height;
            const updateVideoHeight = () => {
                const video = document.getElementById(`pswp-video-${item.id}`);
                const container = video.closest('.pswp-video-container ');
                const style = getComputedStyle(container);

                const windowWidth =
                    container.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
                const windowHeight =
                    container.clientHeight - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom);
                const availableAspectRatio = windowWidth / windowHeight;

                let width, height;

                if (availableAspectRatio > aspectRatio) {
                    // scale by width
                    width = Math.min(item.width, windowHeight * aspectRatio, windowWidth);
                    height = width / aspectRatio;
                } else {
                    // scale by height
                    height = Math.min(item.height, windowWidth / aspectRatio, windowHeight);
                    width = height * aspectRatio;
                }

                video.style.width = `${width}px`;
                video.style.height = `${height}px`;

                if (video.nodeName.toLowerCase() !== 'video') {
                    const el = video.querySelector('video');
                    if (el) {
                        el.style.width = `${width}px`;
                        el.style.height = `${height}px`;
                    }
                }
            };
            window.addEventListener('resize', debounce(updateVideoHeight, 100));
            updateVideoHeight();

            player = videojs(
                element,
                {
                    muted: true,
                    language: 'en',
                    preload: 'auto',
                    fluid: false,
                    // aspectRatio: `${parseInt(item.width)}:${parseInt(item.height)}`,
                    autoplay: true,
                    html5: {
                        hls: {
                            overrideNative: true,
                            limitRenditionByPlayerDimensions: true,
                            useDevicePixelRatio: true,
                            bandwidth: 16777216
                        },
                        nativeAudioTracks: false,
                        nativeVideoTracks: false,
                        useBandwidthFromLocalStorage: true
                    },
                    controlBar: {
                        pictureInPictureToggle: false
                    }
                },
                function() {
                    setTimeout(() => {
                        this.play();
                    }, 0);
                }
            );
            player.httpSourceSelector();
            // player.controls(false)
            player.on('ended', () => {
                player.posterImage.show();
                // vid.bigPlayButton.show();
                player.currentTime(0);
            });

            player.on('touchstart', event => {
                if (event.target.nodeName === 'VIDEO') {
                    if (player.paused()) player.play();
                    else player.pause();
                }
            });

            videojs.log.level('error');

            element.style.opacity = 1;
            element.parentNode.style.opacity = 1;
        }

        if (item.type !== 'video' && player) {
            player.pause();
            player.currentTime(0);
        }
    });
    gallery.listen('close', () => {});
};
